<template>
    <div class="bg-imgs">
        <div>
            <img v-show="index == selectIndex" v-for="(item,index) in bg" :key="item" :class="'bg1'+index" :src="item"/>
        </div>
        <div>
            <img v-show="index == selectIndex" v-for="(item,index) in bg" :key="item" :class="'bg2'+index" :src="item"/>
        </div>
        <div>
            <img v-show="index == selectIndex" v-for="(item,index) in bg" :key="item" :class="'bg3'+index" :src="item"/>
        </div>
        <div>
            <img v-show="index == selectIndex" v-for="(item,index) in bg" :key="item" :class="'bg4'+index" :src="item"/>
        </div>
    </div>
</template>

<script>
export default {
    props: ['bg','selectIndex']
}
</script>

<style scoped>
.bg-imgs {
    position: absolute;
    width: 100%;
    height: 100%;
}

.bg-imgs>div {
    height: 100%;
    width: 25%;
    float: left;
    position: relative;
    overflow: hidden;
}

.bg-imgs div img[class^=bg] {
    height: 100%;
    width: 100%;
    background-repeat: no-repeat;
    position: absolute;
    top: 0px;
}

.bg10,
.bg11,
.bg12{
    left: 0;
    animation: change1Position 5s ease-in-out 0s;
}
.bg20,
.bg21,
.bg22 {
    left: -100%;
    animation: change2Position 5s ease-in-out 0s;
}
.bg30,
.bg31,
.bg32 {
    left: -200%;
    animation: change3Position 5s ease-in-out 0s;
}
.bg40,
.bg41,
.bg42 {
    left: -300%;
    animation: change4Position 5s ease-in-out 0s;
}

@keyframes change1Position{
    0%{        
        opacity: 0.2;
        transform: scale(2,2)
    }
    30%{
        opacity: 1;
        transform: scale(1,1)
    }
    70%{
        opacity: 1;
        transform: scale(1,1)
    }
    100%{
        opacity: 0.2;
        transform: scale(2,2)
    }
}
@keyframes change2Position{
    0%{        
        opacity: 0.2;
        transform: scale(2,2)
    }
    30%{
        opacity: 1;
        transform: scale(1,1)
    }
    70%{
        opacity: 1;
        transform: scale(1,1)
    }
    100%{
        opacity: 0.2;
        transform: scale(2,2)
    }
}
@keyframes change3Position{
    0%{        
        opacity: 0.2;
        transform: scale(2,2)
    }
    30%{
        opacity: 1;
        transform: scale(1,1)
    }
    70%{
        opacity: 1;
        transform: scale(1,1)
    }
    100%{
        opacity: 0.2;
        transform: scale(2,2)
    }
}
@keyframes change4Position{
    0%{        
        opacity: 0.2;
        transform: scale(2,2)
    }
    30%{
        opacity: 1;
        transform: scale(1,1)
    }
    70%{
        opacity: 1;
        transform: scale(1,1)
    }
    100%{
        opacity: 0.2;
        transform: scale(2,2)
    }
}
</style>




// WEBPACK FOOTER //
// src/components/a.header.img.vue